import React from 'react'
import './CoffeeCup.scss'

const CoffeeCup = ({ margin }) => {
    return <div style={{ margin: margin || 'auto' }} className="coffee_cup"></div>
}

export default CoffeeCup